<template>
    <div class="detail-container">
        <div class="detail-bread-crumb-div">
            <ZD-bread-crumb :bConfigList="pageConfig.detailBreadCrumb"></ZD-bread-crumb>
        </div>
        <div class="detail-content-div">
            <div class="detail-content-header-div flex">
                <div class="left-page-title-div flex-1">资费策略</div>
            </div>
            <div class="detail-content-body-div flex-1">
                <div style="display: flex;">
                    
                    <!-- <div class="main-info">
                        <div class="info-top">
                            <div>尖时段</div>
                            <div class="btn-class">
                                <el-button type="primary" size="small" icon="el-icon-edit" circle
                                           @click="handleEdit(1)" ></el-button>
                            </div>
                        </div>
                        <div style="width: 100%; height: 1px; background: #ddd;margin: 24px 0;"></div>
                        <div class="flex-1">
                            <div class="detail-mes-div flex" style="margin-bottom: 24px">
                                <div class="detail-title-div">计费时段：</div>
                                <div>{{'-'}}&nbsp;&nbsp;元</div>
                            </div>
                            <div class="detail-mes-div flex" style="margin-bottom: 24px">
                                <div class="detail-title-div">时段电费：</div>
                                <div>{{'-'}}&nbsp;&nbsp;元</div>
                            </div>
                            <div class="detail-mes-div flex" style="margin-bottom: 24px">
                                <div class="detail-title-div">时段服务费：</div>
                                <div>{{'-'}}&nbsp;&nbsp;元</div>
                            </div>
                            <div class="detail-mes-div flex">
                                <div class="detail-title-div">总费用：</div>
                                <div>{{'-'}}&nbsp;&nbsp;元</div>
                            </div>
                        </div>
                    </div> -->
                   
                    <div class="main-info">
                        <div class="info-top">
                            <div>峰时段</div>
                            <!-- 操作按钮 -->
                            <div class="btn-class">
                                <el-button type="primary" size="small" icon="el-icon-edit" circle @click="handleEdit(2)"></el-button>
                            </div>
                        </div>
                        <div style="width: 100%; height: 1px; background: #ddd;margin: 24px 0;"></div>

                        <div class="flex-1">
                            <div class="detail-mes-div flex" style="margin-bottom: 24px">
                                <div class="detail-title-div" style="width: 70px;">计费时段：</div>
                                <div style="width: calc(100% - 70px);">{{listA.startTimeToEndTime}}</div>
                            </div>
                            <div class="detail-mes-div flex" style="margin-bottom: 24px">
                                <div class="detail-title-div">时段电费：</div>
                                <div>{{listA.chargeVal}}&nbsp;&nbsp;元</div>
                            </div>
                            <div class="detail-mes-div flex" style="margin-bottom: 24px">
                                <div class="detail-title-div">时段服务费：</div>
                                <div>{{listA.serviceVal}}&nbsp;&nbsp;元</div>
                            </div>
                            <div class="detail-mes-div flex">
                                <div class="detail-title-div">总费用：</div>
                                <div>{{listA.totalVal}}&nbsp;&nbsp;元</div>
                            </div>
                        </div>
                    </div>
                    
                    <!-- <div class="main-info">
                        <div class="info-top">
                            <div>平时段</div>
                            <div class="btn-class">
                                <el-button type="primary" size="small" icon="el-icon-edit" circle
                                           @click="handleEdit(3)" ></el-button>
                            </div>
                        </div>
                        <div style="width: 100%; height: 1px; background: #ddd;margin: 24px 0;"></div>
                        <div class="flex-1">
                            <div class="detail-mes-div flex" style="margin-bottom: 24px">
                                <div class="detail-title-div">计费时段：</div>
                                <div>{{'-'}}&nbsp;&nbsp;元</div>
                            </div>
                            <div class="detail-mes-div flex" style="margin-bottom: 24px">
                                <div class="detail-title-div">时段电费：</div>
                                <div>{{'-'}}&nbsp;&nbsp;元</div>
                            </div>
                            <div class="detail-mes-div flex" style="margin-bottom: 24px">
                                <div class="detail-title-div">时段服务费：</div>
                                <div>{{'-'}}&nbsp;&nbsp;元</div>
                            </div>
                            <div class="detail-mes-div flex">
                                <div class="detail-title-div">总费用：</div>
                                <div>{{'-'}}&nbsp;&nbsp;元</div>
                            </div>
                        </div>
                    </div> -->
                   
                    <div class="main-info">
                        <div class="info-top">
                            <div>谷时段</div>
                            <!-- 操作按钮 -->
                            <div class="btn-class">
                                <el-button type="primary" size="small" icon="el-icon-edit" circle @click="handleEdit(4)"></el-button>
                            </div>
                        </div>
                        <div style="width: 100%; height: 1px; background: #ddd;margin: 24px 0;"></div>
                        <div class="flex-1">
                            <div class="detail-mes-div flex" style="margin-bottom: 24px">
                                <div class="detail-title-div" style="width: 70px;">计费时段：</div>
                                <div style="width: calc(100% - 70px);">{{listB.startTimeToEndTime}}</div>
                            </div>
                            <div class="detail-mes-div flex" style="margin-bottom: 24px">
                                <div class="detail-title-div">时段电费：</div>
                                <div>{{listB.chargeVal}}&nbsp;&nbsp;元</div>
                            </div>
                            <div class="detail-mes-div flex" style="margin-bottom: 24px">
                                <div class="detail-title-div">时段服务费：</div>
                                <div>{{listB.serviceVal}}&nbsp;&nbsp;元</div>
                            </div>
                            <div class="detail-mes-div flex">
                                <div class="detail-title-div">总费用：</div>
                                <div>{{listB.totalVal}}&nbsp;&nbsp;元</div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- 标识 -->
                <div class="top-tool">
                    <div class="tool-title">时段费用明细</div>
                    <div class="tool-list">
                        
                        <!-- <div class="list-item">
                            <div class="item-first"></div>
                            <div class="item-title">尖电时刻</div>
                        </div>
                        -->
                        <div class="list-item">
                            <div class="item-second"></div>
                            <div class="item-title">峰电时刻</div>
                        </div>
                        
                        <!-- <div class="list-item">
                            <div class="item-third"></div>
                            <div class="item-title">平电时刻</div>
                        </div>
                        -->
                        <div class="list-item">
                            <div class="item-fourth"></div>
                            <div class="item-title">谷电时刻</div>
                        </div>
                        <div class="list-item">
                            <div class="item-fifth"></div>
                            <div class="item-title">未配置</div>
                        </div>
                    </div>
                </div>
                <el-row>
                    <el-col :xs="1" :sm="1" :md="1" :lg="1" :xl="1" v-for="(i, n) in popup.customizeList">
                        <div style="width: 100%; height: 24px; text-align: center; color: white;">
                           <!-- <div v-if="i.section === '尖'" style="background: #f5222d;">{{ n+1 }}</div> -->
                            <div v-if="i.section === '峰'" style="background: #ffa940;">{{ n+1 }}</div>
                           <!-- <div v-else-if="i.section === '平'" style="background: #52c41a;">{{ n+1 }}</div> -->
                            <div v-else-if="i.section === '谷'" style="background: #00c4af;">{{ n+1 }}</div>
                            <div v-else style="background: #919191">{{ n+1 }}</div>
                        </div>
                    </el-col>
                </el-row>
            </div>

            <div class="detail-content-footer-div">
                <button class="common-bg-button" @click="submitForm">提 交</button>
                <button class="common-empty-button" @click="resetForm">重 置</button>
            </div>
        </div>

        <el-dialog :title="popup.title" :visible.sync="popup.show"  width="50%" :close-on-click-modal="false">
            <el-row :gutter="6">
                <el-col :xs="4" :sm="4" :md="4" :lg="4" :xl="4" v-for="(i, n) in popup.customizeList">
                    <div class="tool-item">
                       <!-- <div @click="handleSelect('尖', i, n)" v-if="i.section === '尖'" style="background: #f5222d">{{ i.startTimeToEndTime }}</div> -->
                        <div @click="handleSelect('峰', i, n)" v-if="i.section === '峰'" style="background: #ffa940">{{ i.startTimeToEndTime }}</div>
                       <!-- <div @click="handleSelect('平', i, n)" v-if="i.section === '平'" style="background: #52c41a">{{ i.startTimeToEndTime }}</div> -->
                        <div @click="handleSelect('谷', i, n)" v-else-if="i.section === '谷'" style="background: #00c4af">{{ i.startTimeToEndTime }}</div>
                        <div @click="handleSelect('', i, n)" v-else style="background: #919191">{{ i.startTimeToEndTime }}</div>
                    </div>
                </el-col>
            </el-row>
            <div class="tool-list" style="margin: 24px 0; justify-content: center;">
                
                <!-- <div class="list-item">
                    <div class="item-first"></div>
                    <div class="item-title">尖电时刻</div>
                </div>
                -->
                <div class="list-item">
                    <div class="item-second"></div>
                    <div class="item-title">峰电时刻</div>
                </div>
                
                <!-- <div class="list-item">
                    <div class="item-third"></div>
                    <div class="item-title">平电时刻</div>
                </div> -->
               
                <div class="list-item">
                    <div class="item-fourth"></div>
                    <div class="item-title">谷电时刻</div>
                </div>
                <div class="list-item">
                    <div class="item-fifth"></div>
                    <div class="item-title">未配置</div>
                </div>
            </div>
            <el-form :model="detailForm" :rules="pageConfig.formRules" ref="detailForm"
                     label-width="88px" class="detail-form" @close="handleCancel">
                <div class="flex detail-form-parent-div">
                    <div class="flex-1">
                        <el-form-item label="时段电费" prop="pileCode">
                            <el-input v-model="detailForm.chargeVal" size="small" style="width: 100%;"></el-input>
                        </el-form-item>
                        <el-form-item label="时段服务费" prop="pileTypeCode">
                            <el-input v-model="detailForm.serviceVal" size="small" style="width: 100%;"></el-input>
                        </el-form-item>
                        <el-form-item label="总费用">
                            <div>{{ numberAdd(detailForm.chargeVal, detailForm.serviceVal) }}  元</div>
                        </el-form-item>
                    </div>
                </div>
            </el-form>
            <div class="btn-class">
                <button class="common-empty-button" @click="handleCancel">取 消</button>
                <button class="common-bg-button" @click="handleSave(popup.section)">保存</button>
            </div>
        </el-dialog>

    </div>
</template>

<script>
    import pageConfig from './page-config';
    export default {
        data() {
            return {
                pageConfig,
                detailForm: {
                    chargeVal: '',
                    serviceVal: '',
                    totalVal: '',
                },
                popup: {
                    title: '',
                    show: false,
                    section: '',
                    customizeList: [
                        {
                            startTimeToEndTime: '00:00-00:59',
                            startTime: '00:00',
                            endTime: '01:00',
                            chargeVal: '',
                            serviceVal: '',
                            totalVal: '',
                            section: '',
                        },
                        {
                            startTimeToEndTime: '01:00-01:59',
                            startTime: '01:00',
                            endTime: '02:00',
                            chargeVal: '',
                            serviceVal: '',
                            totalVal: '',
                            section: '',
                        },
                        {
                            startTimeToEndTime: '02:00-02:59',
                            startTime: '02:00',
                            endTime: '03:00',
                            chargeVal: '',
                            serviceVal: '',
                            totalVal: '',
                            section: '',
                        },
                        {
                            startTimeToEndTime: '03:00-03:59',
                            startTime: '03:00',
                            endTime: '04:00',
                            chargeVal: '',
                            serviceVal: '',
                            totalVal: '',
                            section: '',
                        },
                        {
                            startTimeToEndTime: '04:00-04:59',
                            startTime: '04:00',
                            endTime: '05:00',
                            chargeVal: '',
                            serviceVal: '',
                            totalVal: '',
                            section: '',
                        },
                        {
                            startTimeToEndTime: '05:00-05:59',
                            startTime: '05:00',
                            endTime: '06:00',
                            chargeVal: '',
                            serviceVal: '',
                            totalVal: '',
                            section: '',
                        },
                        {
                            startTimeToEndTime: '06:00-06:59',
                            startTime: '06:00',
                            endTime: '07:00',
                            chargeVal: '',
                            serviceVal: '',
                            totalVal: '',
                            section: '',
                        },
                        {
                            startTimeToEndTime: '07:00-07:59',
                            startTime: '07:00',
                            endTime: '08:00',
                            chargeVal: '',
                            serviceVal: '',
                            totalVal: '',
                            section: '',
                        },
                        {
                            startTimeToEndTime: '08:00-08:59',
                            startTime: '08:00',
                            endTime: '09:00',
                            chargeVal: '',
                            serviceVal: '',
                            totalVal: '',
                            section: '',
                        },
                        {
                            startTimeToEndTime: '09:00-09:59',
                            startTime: '09:00',
                            endTime: '10:00',
                            chargeVal: '',
                            serviceVal: '',
                            totalVal: '',
                            section: '',
                        },
                        {
                            startTimeToEndTime: '10:00-10:59',
                            startTime: '10:00',
                            endTime: '11:00',
                            chargeVal: '',
                            serviceVal: '',
                            totalVal: '',
                            section: '',
                        },
                        {
                            startTimeToEndTime: '11:00-11:59',
                            startTime: '11:00',
                            endTime: '12:00',
                            chargeVal: '',
                            serviceVal: '',
                            totalVal: '',
                            section: '',
                        },
                        {
                            startTimeToEndTime: '12:00-12:59',
                            startTime: '12:00',
                            endTime: '13:00',
                            chargeVal: '',
                            serviceVal: '',
                            totalVal: '',
                            section: '',
                        },
                        {
                            startTimeToEndTime: '13:00-13:59',
                            startTime: '13:00',
                            endTime: '14:00',
                            chargeVal: '',
                            serviceVal: '',
                            totalVal: '',
                            section: '',
                        },
                        {
                            startTimeToEndTime: '14:00-14:59',
                            startTime: '14:00',
                            endTime: '15:00',
                            chargeVal: '',
                            serviceVal: '',
                            totalVal: '',
                            section: '',
                        },
                        {
                            startTimeToEndTime: '15:00-15:59',
                            startTime: '15:00',
                            endTime: '16:00',
                            chargeVal: '',
                            serviceVal: '',
                            totalVal: '',
                            section: '',
                        },
                        {
                            startTimeToEndTime: '16:00-16:59',
                            startTime: '16:00',
                            endTime: '17:00',
                            chargeVal: '',
                            serviceVal: '',
                            totalVal: '',
                            section: '',
                        },
                        {
                            startTimeToEndTime: '17:00-17:59',
                            startTime: '17:00',
                            endTime: '18:00',
                            chargeVal: '',
                            serviceVal: '',
                            totalVal: '',
                            section: '',
                        },
                        {
                            startTimeToEndTime: '18:00-18:59',
                            startTime: '18:00',
                            endTime: '19:00',
                            chargeVal: '',
                            serviceVal: '',
                            totalVal: '',
                            section: '',
                        },
                        {
                            startTimeToEndTime: '19:00-19:59',
                            startTime: '19:00',
                            endTime: '20:00',
                            chargeVal: '',
                            serviceVal: '',
                            totalVal: '',
                            section: '',
                        },
                        {
                            startTimeToEndTime: '20:00-20:59',
                            startTime: '20:00',
                            endTime: '21:00',
                            chargeVal: '',
                            serviceVal: '',
                            totalVal: '',
                            section: '',
                        },
                        {
                            startTimeToEndTime: '21:00-21:59',
                            startTime: '21:00',
                            endTime: '22:00',
                            chargeVal: '',
                            serviceVal: '',
                            totalVal: '',
                            section: '',
                        },
                        {
                            startTimeToEndTime: '22:00-22:59',
                            startTime: '22:00',
                            endTime: '23:00',
                            chargeVal: '',
                            serviceVal: '',
                            totalVal: '',
                            section: '',
                        },
                        {
                            startTimeToEndTime: '23:00-23:59',
                            startTime: '23:00',
                            endTime: '24:00',
                            chargeVal: '',
                            serviceVal: '',
                            totalVal: '',
                            section: '',
                        }
                    ],
                },
                queryInfo: {
                    chargeNo: '',
                    stationNo: '',
                },
                listA: {}, // 峰
                listB: {}, // 谷
                // listC: {}, // 尖
                // listD: {}, // 平
            }
        },
        mounted() {
            this.init();
        },
        methods: {
            // 初始化
            init() {
                let _ = this;
                _.queryInfo.chargeNo = _.$store.state.editId;
                _.queryInfo.stationNo = _.$route.query.stationNo;
                _.$H.post(_, _.$A.pilestation.findNoOrStationCode, _.queryInfo).then(res => {
                    let list = res.data
                    if(list.status === 200){
                        _.queryInfo.id = list.data.id || '';
                        _.popup.customizeList = list.data.customizeList;
                        let flagA = [];
                        let flagB = [];
                        // let flagC = [];
                        // let flagD = [];
                        list.data.customizeList.forEach(li => {
                            if(li.section === '峰'){
                                flagA.push(li)
                            }
                            if(li.section === '谷'){
                                flagB.push(li)
                            }
                            // if(li.section === '尖'){
                            //     flagC.push(li)
                            // }
                            // if(li.section === '平'){
                            //     flagD.push(li)
                            // }
                        })

                        _.listA = {
                            chargeVal: flagA[0].chargeVal,
                            serviceVal: flagA[0].serviceVal,
                            totalVal: flagA[0].totalVal,
                            section: flagA[0].section,
                        }
                        _.listB = {
                            chargeVal: flagB[0].chargeVal,
                            serviceVal: flagB[0].serviceVal,
                            totalVal: flagB[0].totalVal,
                            section: flagB[0].section,
                        }
                        // _.listC = {
                        //     chargeVal: flagC[0].chargeVal,
                        //     serviceVal: flagC[0].serviceVal,
                        //     totalVal: flagC[0].totalVal,
                        //     section: flagC[0].section,
                        // }
                        // _.listD = {
                        //     chargeVal: flagD[0].chargeVal,
                        //     serviceVal: flagD[0].serviceVal,
                        //     totalVal: flagD[0].totalVal,
                        //     section: flagD[0].section,
                        // }
                        flagA.forEach((li, n) => {
                            // 峰
                            if(n === 0){
                                _.listA.startTimeToEndTime = li.startTimeToEndTime;
                            } else {
                                _.listA.startTimeToEndTime = _.listA.startTimeToEndTime + ', ' + li.startTimeToEndTime;
                            }
                        })
                        flagB.forEach((li, n) => {
                            // 谷
                            if(n === 0){
                                _.listB.startTimeToEndTime = li.startTimeToEndTime;
                            } else {
                                _.listB.startTimeToEndTime = _.listB.startTimeToEndTime + ', ' + li.startTimeToEndTime;
                            }
                        })
                        // flagC.forEach((li, n) => {
                        //     // 尖
                        //     if(n === 0){
                        //         _.listC.startTimeToEndTime = li.startTimeToEndTime;
                        //     } else {
                        //         _.listC.startTimeToEndTime = _.listC.startTimeToEndTime + ', ' + li.startTimeToEndTime;
                        //     }
                        // })
                        // flagD.forEach((li, n) => {
                        //     // 平
                        //     if(n === 0){
                        //         _.listD.startTimeToEndTime = li.startTimeToEndTime;
                        //     } else {
                        //         _.listD.startTimeToEndTime = _.listD.startTimeToEndTime + ', ' + li.startTimeToEndTime;
                        //     }
                        // })
                    }
                })
            },
            // 编辑
            handleEdit(val){
                console.log(val);
                let _ = this;
                // if(val === 1){
                //     _.popup.title = '尖时资费策略';
                //     _.popup.section = '尖';
                //     _.detailForm = _.listC;
                // }
                if(val === 2){
                    _.popup.title = '峰时资费策略';
                    _.popup.section = '峰';
                    _.detailForm = _.listA;
                }
                // if(val === 3){
                //     _.popup.title = '平时资费策略';
                //     _.popup.section = '平';
                //     _.detailForm = _.listD;
                // }
                if(val === 4){
                    _.popup.title = '谷时资费策略';
                    _.popup.section = '谷';
                    _.detailForm = _.listB;
                }
                _.popup.show = true;
            },
            // 时段选择
            handleSelect(val, row, n){
                
                let _ = this;
                
                if (_.popup.section === row.section ){
                    _.popup.customizeList[n].section = ''
                } else {
                    _.popup.customizeList[n].section = _.popup.section;
                }
                if(val === ''){
                    _.popup.customizeList[n].section = _.popup.section;
                }
                // console.log(row.section);
            },
            // 总费用计算
            numberAdd(arg1, arg2){
                let r1, r2, m, n;
                try {
                    r1 = arg1.toString().split(".")[1].length
                } catch (e) {
                    r1 = 0
                }
                try {
                    r2 = arg2.toString().split(".")[1].length
                } catch (e) {
                    r2 = 0
                }
                m = Math.pow(10, Math.max(r1, r2))
                n = (r1 >= r2) ? r1 : r2;
                if(!arg1) arg1 = 0;
                if(!arg2) arg2 = 0;
                return ((arg1 * m + arg2 * m) / m).toFixed(n);
            },
            // 配置时段-编辑保存
            handleSave(val){
                let _ = this;
                let flag = false;
                if(_.detailForm.chargeVal === '' || _.detailForm.serviceVal === ''){
                    flag = true
                }
                if(flag) return _.$U.error('请填写时段电费、服务费！')
                _.popup.customizeList.forEach(li => {
                    if(val === li.section){
                        li.chargeVal = _.detailForm.chargeVal;
                        li.serviceVal = _.detailForm.serviceVal;
                        li.totalVal = _.numberAdd(li.chargeVal, li.serviceVal);
                    }
                })
                _.popup.show = false;
            },
            // 配置时段-编辑取消
            handleCancel(){
                let _ = this;
                _.detailForm = {};
                _.popup.show = false;
            },
            // 提交
            submitForm(){
                let _ = this;
                let flag = false
                let params = {
                    id: _.queryInfo.id || '',
                    chargeNo: _.queryInfo.chargeNo,
                    stationNo: _.queryInfo.stationNo,
                    customizeList: _.popup.customizeList
                }
                _.popup.customizeList.forEach(li => {
                    if(!li.section){
                        flag = true
                    }
                })
                if(flag) return _.$U.error('计费时段不能空闲！')
                _.$H.post(_, _.$A.pilestation.updateCustomize, params).then(res => {
                    if(res.data.status === 200){
                        _.$U.success('保存成功！')
                        _.init();
                    }
                })
            },
            // 重置
            resetForm(){
                let _ = this;
                _.detailForm = {};
                _.popup.customizeList.forEach(li => {
                    li.section = '';
                })
                _.init();
            },

        },
    }
</script>

<style lang="less" scoped>

    .main-info:nth-child(2){
        margin-left: 20px;
        margin-right: 10px;
    }
    .main-info:nth-child(3){
        margin-left: 10px;
        margin-right: 20px;
    }
    .main-info{
        width: calc((100% / 2) - 15px);
        display: flex;
        flex-direction: column;
        border: 1px solid #ddd;
        padding: 24px;
        box-sizing: border-box;
        border-radius: 8px;
        font-size: 14px;

        .info-top{
            display: flex;
            justify-content: space-between;
            align-items: center;
        }

    }

    /deep/ .el-button--primary{
        background-color: #B780F3;
        border-color: #B780F3;
    }

    /deep/ .el-button--primary.is-disabled, .el-button--primary.is-disabled:active, .el-button--primary.is-disabled:focus, .el-button--primary.is-disabled:hover{
        color: #FFF;
        background-color: #dec5f9;
        border-color: #dec5f9;
    }

    .top-tool{
        display: flex;
        align-items: center;
        justify-content: flex-start;
        font-size: 14px;
        margin: 24px 0;
    }
    .tool-title{
        font-weight: 500;
        margin-right: 24px;
    }
    .tool-list{
        display: flex;
        align-items: center;
        justify-content: flex-start;

        .list-item{
            display: flex;
            align-items: center;
            justify-content: center;
            margin-right: 12px;

            .item-first, .item-second, .item-third, .item-fourth, .item-fifth{
                width: 10px;
                height: 10px;
                border-radius: 10px;
                margin-right: 6px;
            }
            .item-first{
                background: #f5222d;
            }
            .item-second{
                background: #ffa940;
            }
            .item-third{
                background: #52c41a;
            }
            .item-fourth{
                background: #00c4af;
            }
            .item-fifth{
                background: #919191;
            }
        }
    }

    .btn-class{
        display: flex;
        align-items: center;
        justify-content: flex-end;
    }

    .tool-item{
        width: 100%;
        height: calc((100vh / 4) - 100px);
        line-height: calc((100vh / 4) - 100px);
        text-align: center;
        color: white;
        cursor: pointer;
        margin-bottom: 6px;

        div{
            width: 100%;
            height: 100%;
        }
    }

</style>
